<template>
  <div class="gui-flex gui-flex-rows">
    <p class="body-3 mb-3 bold">Spoření č. 1</p>
    <div class="table-border__radius elevation-1 mb-3">
      <v-data-table
        :headers="headers"
        :items="bonusy"
        hide-controls
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.datum_od }} - {{ props.item.datum_do }}</td>
          <td class="text-xs-right"><span v-if="props.item.castka > 0">{{ props.item.castka | formatMoney }} {{mena.zkratka}}</span></td>
          <td class="text-xs-right">{{ props.item.bonusovy_kov | formatMoney }} g</td>
          <td class="text-xs-right">{{ props.item.bonusovy_kov_castka | formatMoney }} Kč</td>
          <td class="text-xs-right"><span v-if="props.item.datum_pripsani != null">ANO ({{ props.item.datum_pripsani | formatSimpleDate }})</span></td>
        </template>
      </v-data-table>
    </div>
    <p class="body-3 mb-0" v-if="narok.zbyva_zaplatit > 0"><span class="bold">Pozn.</span>:
      Předběžný nárok je <span class="bold">{{narok.g | formatMoney}} g</span> bonusového kovu. Bonusový kov bude připsán
      na Váš spořící účet, pokud do <span class="bold">31. 12.</span> dopošlete <span class="bold">{{narok.zbyva_zaplatit | formatMoney}} Kč</span>.
    </p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Částka platby', value: 'castka_platby', align: 'right' },
        { text: 'Bonusový kov', value: 'bonusovy_kov', align: 'right' },
        { text: 'Bonus v Kč', value: 'bonus_kc', align: 'right' },
        { text: 'Připsáno', value: 'datum_pripsani', align: 'right' },
      ]
    }
  },
  mounted: function() {

  },
  props: {
    id: String,
    bonusy: Array,
    mena: Object,
    narok: Object
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Klienti/RocniBonusy.vue